const deps = [];

module.exports = angular
  .module('bench.data.actions.mainapp', deps)

  .factory('MainappActions', () => ({
    ledgerChanged() {
      return 'bl.pubnub.categorizationRequested.#{clientId}';
    },
  }));
